
























import inputMixin from 'library/mixins/input-mixin'
export default

	mixins: [ inputMixin ]

	props:

		# Type of textfield
		type:
			type: String
			default: 'text'

		inverted:
			type: Boolean
			default: false

		half:
			type: Boolean
			default: false

		name:
			type: String
			default: ''

		readonly:
			type: Boolean
			default: false

		noPill:
			type: Boolean
			default: false

		placeholder:
			type: String
			default: null

		autocomplete:
			type: String
			default: 'off'

		autocorrect:
			type: String
			default: 'on'

		autocapitalize:
			type: String
			default: 'on'

		minlength:
			type: String
			default: '1'

		maxlength:
			type: String
			default: '100'

	computed:

		classes: -> [
			'inverted' if @inverted
			'half' if @half
			'no-pill' if @noPill
		]

